import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 528px;
`;

export const Content = styled.div`
  background: #fff;
  width: 100%;
`;
export const Group = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const OpenGroupWrapper = styled.div`
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 12px;
`;
export const Row = styled.div`
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  padding-left: 24px;
  margin-top: 12px;
`;

export const ArrowIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  cursor: pointer;
  ${({ isOpen }) =>
    isOpen
      ? css`
          svg {
            fill: ${Palette.Primary._500};
          }
        `
      : css`
          svg {
            fill: ${Palette.PrimaryGray._400};
          }
        `}
`;

const highlightStyle = css`
  & strong {
    color: ${Palette.Primary._500};
    font-weight: inherit;
  }
`;

export const GroupName = styled.label`
  font-weight: 500;
  font-size: 14px;
  color: ${Palette.PrimaryGray._700};
  ${highlightStyle}
  margin-left: 8px;
`;
export const GroupMarker = styled.span`
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: ${() => Palette.PrimaryGray._400};
  padding-right: 24px;
`;

export const ChooseItemRow = styled.div`
  display: flex;
  align-items: center;
  background: ${() => Palette.PrimaryGray._000};
  padding: 0px 0px;
  justify-content: space-between;
  > :first-child {
    max-width: 80%;
  }
`;

export const ItemName = styled.div`
  margin-left: 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
  ${highlightStyle}
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const ItemNameMarker = styled(ItemName)`
  display: flex;
  justify-content: flex-start;
  margin-left: 0;
  font-weight: 400;
  margin-right: 15px;
  min-width: 10%;
  white-space: nowrap;
  color: ${() => Palette.PrimaryGray._500};
  > :nth-child(2) {
    color: ${() => Palette.PrimaryGray._700};
  }
`;

export const WrapForChooseRows = styled.div`
  > :first-child {
    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  }
`;

export const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  > :first-child {
    min-width: 60px;
  }
`;
